import { useCallback, useEffect, useState } from 'react';
import {
  CONSENT_CHANGE_EVENT,
  ConsentDecision,
  getConsent,
  setConsent,
} from '../utils/cookieConsent';

export function useCookieConsent(): {
  consent: ConsentDecision | null;
  accept: () => void;
  decline: () => void;
} {
  const [consentState, setConsentState] = useState<ConsentDecision | null>(() => getConsent());

  useEffect(() => {
    const sync = () => setConsentState(getConsent());
    window.addEventListener(CONSENT_CHANGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CONSENT_CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const accept = useCallback(() => setConsent(ConsentDecision.GRANTED), []);
  const decline = useCallback(() => setConsent(ConsentDecision.DENIED), []);

  return { consent: consentState, accept, decline };
}
